'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createJsonPatchOperation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createClient;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _tokenRequester = require('./tokenRequester');

var _tokenRequester2 = _interopRequireDefault(_tokenRequester);

var _createJsonPatchOperation2 = require('./createJsonPatchOperation');

var _createJsonPatchOperation3 = _interopRequireDefault(_createJsonPatchOperation2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.createJsonPatchOperation = _createJsonPatchOperation3.default;
function createClient(baseUrl, tokenRequestUrl) {
    var headerKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'X-EconomicToken';
    var tokenName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var tokenTimeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 62;

    var client = _axios2.default.create({ baseURL: baseUrl });

    if (tokenRequestUrl) {
        client.interceptors.request.use(function (config) {
            return (0, _tokenRequester2.default)(tokenRequestUrl, tokenTimeout).then(function (token) {
                return _extends({}, config, {
                    headers: _extends({}, config.headers, _defineProperty({}, headerKey, tokenName + token))
                });
            });
        }, Promise.reject);
    }

    return client;
}